import { AxiosRequestConfig } from "axios";

import { ApiError } from "@/interfaces/api";
import { Audience } from "@/types";

import { fetchData } from "@/api/utils";

type DeleteAudienceApiResponse = {
  data: Array<Audience>;
  error: ApiError | null;
};

const deleteAudience = async (
  accessToken: string,
  name: string
): Promise<DeleteAudienceApiResponse> => {
  const url = `${process.env.REACT_APP_API_URL}/audience?audience_name=${encodeURIComponent(name)}`;

  const config: AxiosRequestConfig = {
    method: "DELETE",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

export default deleteAudience;
